import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import styled from 'styled-components';
import { IAlternative } from '../../../types';

interface IProps {
  alternatives: IAlternative[];
}

const GridQuestionHeader = ({ alternatives }: IProps) => {
  const largeScreen = useMediaQuery('(min-width:450px)');
  return (
    <FullwidthContainer>
      <Grid container spacing={0}>
        <Grid item xs={4} />
        <Grid item xs={8}>
          <Grid justify="space-evenly" container>
            {alternatives.map((alternative, index) => {
              return (
                <Grid key={alternative.text} item xs={2}>
                  <QuestionTypography>{`${index + 1} - ${
                    largeScreen ? alternative.text : ''
                  }`}</QuestionTypography>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </FullwidthContainer>
  );
};

const QuestionTypography = styled.div`
  font-family: EB Garamond;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: center;
  white-space: nowrap;
`;

const FullwidthContainer = styled.div`
  width: 100%;
`;

export default GridQuestionHeader;
